/**
 * Global State Variables
 *
 * Mutable state shared across multiple feature modules. Each variable has a
 * corresponding setter function (needed because ES modules export
 * live bindings but only the declaring module can reassign `let`).
 *
 * Single-file state has been localized to the consuming module.
 */
import type { Editor } from "ckeditor5";

// Editor state
export let htmleditor: Editor | null = null;

// Timer references (multi-file)
export let loadmoretimer: ReturnType<typeof setTimeout> | undefined;

// UI state flags (multi-file)
export let suppressKeyHandlers = 0;
export let topSearchActive = 0;
export let stickyHeaderEnabled = 0;
export let openModalCount = 0;
export let load_active = 0;
export let search_active = 0;
export let reordermode = 0;
export let reorderSelectedCount = 0;
export let transfer_show = 0;

// Cache variables
export let searchcache = 0;

// Modal state tracking
export let last_modal_open = "";
export let modal_open_what = "";
export let premodal_url = "";
export const open_modal_id: string[] = [];
export const open_modal_url: string[] = [];
export const open_modal_what: string[] = [];
export const open_modal_size: string[] = [];
export const open_modal_title: string[] = [];

// Counter variables
export let generalcounter = 0;

// Mobile detection
export let ismobile = 0;

/**
 * Initialize the ismobile flag from the window width.
 */
export function initWindowDimensions(): void {
  const width =
    typeof window.innerWidth === "number"
      ? window.innerWidth
      : document.documentElement.clientWidth || document.body.clientWidth;

  if (width < 900) {
    ismobile = 1;
  }
}

// State setters
export function setHtmleditor(value: Editor | null): void {
  htmleditor = value;
}
export function setLoadmoretimer(value: ReturnType<typeof setTimeout> | undefined): void {
  loadmoretimer = value;
}
export function setSuppressKeyHandlers(value: number): void {
  suppressKeyHandlers = value;
}
export function setTopSearchActive(value: number): void {
  topSearchActive = value;
}
export function setStickyHeaderEnabled(value: number): void {
  stickyHeaderEnabled = value;
}
export function setModalOpen(value: number): void {
  openModalCount = value;
}
export function setLoadActive(value: number): void {
  load_active = value;
}
export function setSearchActive(value: number): void {
  search_active = value;
}
export function setReordermode(value: number): void {
  reordermode = value;
}
export function setReorderSelectedCount(value: number): void {
  reorderSelectedCount = value;
}
export function setTransferShow(value: number): void {
  transfer_show = value;
}
export function setIsmobile(value: number): void {
  ismobile = value;
}
export function setGeneralcounter(value: number): void {
  generalcounter = value;
}
export function setSearchcache(value: number): void {
  searchcache = value;
}
export function setLastModalOpen(value: string): void {
  last_modal_open = value;
}
export function setModalOpenWhat(value: string): void {
  modal_open_what = value;
}
export function setPremodalUrl(value: string): void {
  premodal_url = value;
}
